import React from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import ProviderApprovalRequestTable from '../../components/Table/ProviderApprovalRequestTable';
import { Link,Outlet,useNavigate, useLocation } from 'react-router-dom';
import { useApprovalRequest } from '../../Context/ApprovalRequestContext';
const ViewProvider = () => {
     const navigate = useNavigate();
     const location = useLocation();
     const { updatePendingCount } = useApprovalRequest();
 
     console.log('location', location)
  return (
     <div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='RegisterProviderText'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}>Provider Approval Requests</span> 
   {/* <Button onClick={()=>{
    navigate('/admin-panel/CheckProviderDetail/RegisterNewDataProvider');
   }}  variant="contained">Transaction Report</Button>  */}
    </div>     
 

     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                           
                            <div style={{width:"98%",marginTop:40}}>
                                <ProviderApprovalRequestTable onRequestCountChange={updatePendingCount}/>    
                            </div>  
                            
            </div>
         
</div>
  )
}

export default ViewProvider